import { BaseModel } from "@blue-chip/core";
import Scope from "./Scope";
import Spec from "./Spec";
import SpecCategoryDetail from "./SpecCategoryDetail";
import TemplateCategory from "./TemplateCategory";

export default class SpecCategory extends BaseModel {
  static get belongsTo() {
    return [Spec, TemplateCategory, Scope];
  }

  static get hasMany() {
    return [SpecCategoryDetail];
  }
}

export const getSpecCategoryLabel = ({ name, isActive } = {}) => {
  if (!name) return "";
  return isActive ? name : `${name} (Inactive)`;
};
